export enum WebsiteLogoSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
